import React, { FC } from "react";
import { IFormItem } from "../Types";
import { Form, TimePicker } from "antd";

export const __FormTimePicker: FC<IFormItem> = (props) => {
    return (
        <Form.Item
            label={props.fieldLabel}
            name={props.fieldName}
            rules={props.rules}
            hidden={props.hidden}
        >
            <TimePicker
                // format={props?.format ?? "YYYY-MM-DD"}
                format={props?.format ?? "HH:mm:ss"}
                disabled={props.disable}
                allowClear
                showNow={true}
            />
        </Form.Item>
    )
}